// Format band motion (3 Oct 2026, round 8). Everything is visible by default. Parts still below the fold at load are armed
// (their start state set without transitions) and play as they come into view: the picture's moment, then each chart on its
// own (the bars fill, and a counting number counts up with its bar). Nothing moves for people who ask for reduced motion.
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function when(node, opts, fn) { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, opts); io.observe(node); }
  function count(chart) {
    each(chart.querySelectorAll('.ol-fx__count[data-to]'), function (n) {
      var to = +n.getAttribute('data-to'), cs = getComputedStyle(n.closest('.ol-fx__row').querySelector('.ol-fx__fill'));
      var dur = (parseFloat(cs.transitionDuration) || 1) * 1000, delay = (parseFloat(cs.transitionDelay) || 0) * 1000, t0 = null;
      function step(ts) { if (t0 === null) t0 = ts; var p = Math.min(1, Math.max(0, (ts - t0 - delay) / dur)); n.textContent = String(Math.round(to * (1 - Math.pow(1 - p, 4)))); if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }
  // the counting numbers keep their final figure's exact width: every figure written first, every width read in one layout,
  // then the widths and the zeros written (was a write, a read and a write for each number, a forced layout each time)
  function reserve(charts) {
    var ns = [];
    charts.forEach(function (c) { each(c.querySelectorAll('.ol-fx__count[data-to]'), function (n) { ns.push(n); }); });
    ns.forEach(function (n) { n.style.minWidth = ''; n.textContent = n.getAttribute('data-to'); });
    var widths = ns.map(function (n) { return n.getBoundingClientRect().width; });
    ns.forEach(function (n, i) { n.style.minWidth = widths[i] + 'px'; n.textContent = '0'; });
  }
  each(document.querySelectorAll('.ol-fx:not([data-fx])'), function (el) {
    el.setAttribute('data-fx', '');
    if (reduce || !('IntersectionObserver' in window)) return;
    var media = el.querySelector('.ol-fx__media');
    var parts = Array.prototype.slice.call(el.querySelectorAll('.ol-fx__chart'));
    if (media) parts.unshift(media);
    if (!parts.length) return;
    // where each part sits comes from one observer's first report, measured by the browser in its own layout (8 Oct 2026, speed)
    var first = new IntersectionObserver(function (entries) {
      first.disconnect();
      var low = window.innerHeight * 0.85, armed = [];
      el.classList.add('fx-instant');
      entries.forEach(function (e) {
        var part = e.target;
        if (e.boundingClientRect.top < low) { part.classList.add('is-in'); return; }
        armed.push(part);
        if (part === media) { when(media, { threshold: 0.35 }, function () { media.classList.add('is-in'); }); return; }
        when(part, { rootMargin: '0px 0px -12% 0px' }, function () { part.classList.add('is-in'); count(part); });
      });
      var charts = armed.filter(function (p) { return p !== media; });
      if (charts.length) {
        reserve(charts);
        // the brand font can still be loading: measure again once it's in, for the charts still waiting below the fold
        if (document.fonts && document.fonts.status !== 'loaded') document.fonts.ready.then(function () { reserve(charts.filter(function (c) { return !c.classList.contains('is-in'); })); });
      }
      if (armed.length) el.classList.add('is-armed');
      // one frame drawn in the start state without transitions, then transitions back on (replaces the forced reflow)
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('fx-instant'); }); });
    });
    parts.forEach(function (p) { first.observe(p); });
  });
})();
